export default __webpack_public_path__ + "static/media/leaderboard-en.86607d36.png";